import Vue from 'vue';

Vue.component('stagger-list', {
    functional: true,
    render(createElement, context) {
        const data = {
            props: {
                name: 'v-staggerList',
                tag: 'ul',
                class: 'v-staggerList',
                appear: true,
            },
            on: {
                beforeEnter(el) {
                    el.style.transition = '400ms';
                    el.style.transform = 'translateX(-16px)'
                    el.style.opacity = 0;
                },
                enter(el, done) {
                    const delay = el.dataset.index * context.props.time + 200;
                    setTimeout(() => {
                        el.style.opacity = 1;
                        el.style.transform = 'translateX(0)';
                    }, delay);
                },
                leave(el, done) {
                    // const delay = el.dataset.index * context.props.time + 200;
                    el.style.opacity = 0;
                    el.style.transform = 'translateX(16px)';
                    el.style.height = 0;
                    setTimeout(done, 300);
                    // setTimeout(() => {
                    //     done()
                    // }, delay);
                }
            }
        }

        return createElement('transition-group', data, context.children);
    },
});
